export default __webpack_public_path__ + "static/media/Map.f2d99af8.svg";